import { BulkSpreadsheet, parseBool, type BulkColumn } from '../shared/BulkSpreadsheet';
import { roleService } from '@kss/api';
import type { RoleCreate } from '@kss/api';

const columns: BulkColumn<RoleCreate>[] = [
  { key: 'name', header: 'Name', required: true, sample: 'Manager' },
  { key: 'code', header: 'Code', sample: 'manager' },
  { key: 'description', header: 'Description' },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkRole() {
  return (
    <BulkSpreadsheet<RoleCreate> title="Bulk import roles" entityLabel="role" backPath="/panel/roles" columns={columns} module="Role"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, isActive: r.isActive ?? true }));
        const created = await roleService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
